import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PREMIUM_OFFER, PRICING } from '../data/content';
export function PremiumOfferCard() {
  const offer = PREMIUM_OFFER;
  return <article className="relative flex h-full flex-col rounded-3xl border-2 border-lime bg-rose-deep p-6 pt-9 shadow-[0_22px_50px_rgba(0,0,0,0.4)] sm:p-8 sm:pt-10" data-id="element-13" data-mp="76afrdshfs65">
      <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-lime px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-14" data-mp="3tm4roskb7iva">
        <span aria-hidden="true" data-id="element-15" data-mp="3km8bzgfwducd">⭐ </span>Opción más elegida
      </span>

      <header className="text-center" data-id="element-16" data-mp="3kjvl2ds5w9n6">
        <h3 className="font-display text-xl uppercase leading-tight text-snow sm:text-2xl" data-id="element-17" data-mp="3pk04ocod9khm">{offer.name}</h3>
        <p className="mx-auto mt-2 max-w-sm text-sm leading-snug text-snow-muted" data-id="element-18" data-mp="3aok5jt8xiyed">{offer.tagline}</p>
        <p className="mt-5 font-display text-5xl leading-none text-snow sm:text-6xl" data-id="element-19" data-mp="3flkag0u1lv3w">
          {offer.price} <span className="font-sans text-base font-bold text-snow-muted" data-id="element-20" data-mp="11w26gc3yr0e8">{PRICING.currency}</span>
        </p>
        <p className="mt-2 text-sm font-bold text-snow" data-id="element-21" data-mp="wximgh8xjyoi">Un solo pago.</p>
      </header>

      <div className="mt-6 border-t border-snow/25 pt-6" data-id="element-22" data-mp="1awrz56xxganq">
        <p className="text-sm font-extrabold text-snow" data-id="element-23" data-mp="16w83k7t05f3p">Recibís todo el Megapack:</p>
        <ul className="mt-3 space-y-2" data-id="element-24" data-mp="16udkz057dz2s">
          {offer.baseIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm font-medium text-snow" data-id="element-25" data-mp="j4j9alwmegk4">
              <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-26" data-mp="e5g1itp99w8g" />
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-sm font-extrabold text-lime" data-id="element-27" data-mp="n764mwsi2jm2">Y además, estos dos recursos exclusivos:</p>

        <div className="mt-3 space-y-3" data-id="element-28" data-mp="3vmzb0it4aepe">
          {offer.extras.map(extra => <section key={extra.title} className="rounded-2xl bg-ink/60 p-4 sm:p-5" aria-label={extra.title} data-id="element-29" data-mp="3rn8nqp2sugpm">
              <h4 className="font-display text-base text-snow sm:text-lg" data-id="element-30" data-mp="1ukrqmh3axinr">
                <span aria-hidden="true" data-id="element-31" data-mp="1zke14irqwksv">{extra.icon} </span>
                {extra.title}
              </h4>
              <p className="mt-1.5 text-[13px] leading-snug text-snow-muted" data-id="element-32" data-mp="24bcjdnwansyr">{extra.intro}</p>
              <ul className="mt-3 space-y-2" data-id="element-33" data-mp="29b8nro8wlmeu">
                {extra.items.map(item => {
              const [lead, ...rest] = item.split(': ');
              return <li key={item} className="flex items-start gap-2.5 text-[13px] leading-snug text-snow" data-id="element-34" data-mp="1gls0f5054vph">
                      <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-35" data-mp="1lklfh1v2surr" />
                      <span data-id="element-36" data-mp="1qkhk93blkq8d">
                        {rest.length ? <>
                            <strong className="font-bold" data-id="element-37" data-mp="2x12zu3lef6y1">{lead}:</strong> {rest.join(': ')}
                          </> : item}
                      </span>
                    </li>;
            })}
              </ul>
            </section>)}
        </div>

        <p className="mt-4 text-center text-xs italic leading-snug text-snow-dim" data-id="element-38" data-mp="lfanay9utw0i">{offer.note}</p>
      </div>

      <div className="mt-auto pt-6 text-center" data-id="element-39" data-mp="bn4y1wazlsp0">
        <p className="text-sm font-bold text-lime" data-id="element-40" data-mp="bmbt90vl9d9i">{offer.upsell}</p>
        <CtaButton variant="lime" className="mt-4 w-full !px-5" href={offer.checkoutUrl || undefined} data-id="element-41" data-mp="6ojw9sg370yg">
          {offer.cta} <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-42" data-mp="2ldo2f9eyzpc" />
        </CtaButton>
        <p className="mt-3 text-xs font-semibold text-snow-muted" data-id="element-43" data-mp="3ttsxp6n9pnna">{offer.summary}</p>
      </div>
    </article>;
}